import React from 'react';
import { Button } from './ui/button';
import { Scissors, Phone } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1585747860715-2ba37e788b70?q=80&w=2574&auto=format&fit=crop')"
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        <div className="max-w-5xl space-y-6 animate-fade-in mt-16 md:mt-0">
          {/* Logo */}
          <div className="flex justify-center mb-6 md:mb-8">
            <div className="relative">
              {/* Glow effect background */}
              <div className="absolute inset-0 bg-gradient-radial from-[#C9A227]/20 via-transparent to-transparent blur-3xl scale-110"></div>
              <img 
                src="/marks-barber-logo-transparent.png" 
                alt="Mark's Barber Logo" 
                className="relative w-48 h-48 md:w-72 md:h-72 object-contain"
                style={{
                  filter: 'drop-shadow(0 0 40px rgba(201, 162, 39, 0.6)) drop-shadow(0 0 80px rgba(201, 162, 39, 0.3))'
                }}
              />
            </div>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl md:text-8xl font-bold text-white tracking-tight leading-none">
            <span className="block font-playfair">More Than A Haircut.</span>
            <span className="block mt-3 md:mt-4 text-[#C9A227] font-playfair">A Premium Grooming Experience.</span>
          </h1>

          {/* Subheading */}
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto font-light leading-relaxed">
            Experience timeless craftsmanship, modern style, and professional grooming tailored for today's gentlemen.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <Button 
              size="lg"
              onClick={() => scrollToSection('branches')}
              className="bg-[#C9A227] hover:bg-[#B89220] text-black font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#C9A227]/50"
            >
              Book Appointment
            </Button>
            <Button 
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('branches')}
              className="border-2 border-white text-white hover:bg-white hover:text-black font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 backdrop-blur-sm"
            >
              View Our Branches
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
            <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
              <div className="w-1 h-3 bg-[#C9A227] rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;